export default "__VITE_ASSET__B6qu4LXL__"